import type Hls from 'hls.js';
import type { HlsConfig } from 'hls.js';

let _ctor: typeof Hls | null = null;

/** Lazy-load hls.js exactly once (Vite emits a separate hashed chunk). */
export async function ensureHls(): Promise<typeof Hls> {
  if (_ctor) return _ctor;
  const mod = await import('hls.js');
  _ctor = mod.default;
  return _ctor;
}

/** Safari/iOS play HLS natively — no hls.js download needed. */
export const canPlayNativeHls = (v: HTMLVideoElement): boolean =>
  v.canPlayType('application/vnd.apple.mpegurl') !== '';

/** Tuned for a wall of many live tiles: tiny buffers, no LL churn, worker demux. */
export const gridConfig = (): Partial<HlsConfig> => ({
  liveSyncDuration: 2,
  liveMaxLatencyDuration: 6,
  liveDurationInfinity: true,
  maxBufferLength: 4,
  maxMaxBufferLength: 8,
  backBufferLength: 0,
  enableWorker: true,
  lowLatencyMode: false,
  capLevelToPlayerSize: true,
  fragLoadingMaxRetry: 6,
  manifestLoadingMaxRetry: 6,
});

/** One large hero view — bigger buffer, ABR unlocked. */
export const focusConfig = (): Partial<HlsConfig> => ({
  liveSyncDuration: 3,
  liveMaxLatencyDuration: 10,
  liveDurationInfinity: true,
  maxBufferLength: 12,
  maxMaxBufferLength: 30,
  backBufferLength: 0,
  enableWorker: true,
  lowLatencyMode: false,
  capLevelToPlayerSize: true,
  fragLoadingMaxRetry: 6,
  manifestLoadingMaxRetry: 6,
});
